import React from 'react';
import './Content.css';
import LoginForm from '../LoginForm/LoginForm';

const Content = () => {
    return (
        <div className='skali-home-page'>
            <div className='row'>
                <div className='w-50'>
                    <div className='inner'>
                        <h1>Welcome to SKALI: Revolutionize Emergency Care</h1>
                        <p>Transforming urgent care with passion and  innovative technology.</p>
                    </div>
                </div>
                <div className='w-50'>
                    <LoginForm />
                </div>
            </div>
        </div>
    );
}

export default Content;
